<template>
  <div class="header-links">
    <a
      v-for="link in this.$root.links"
      :key="link.href"
      :href="`#${encodeURIComponent(link.href)}`"
    >
      {{ link.label }}
    </a>
  </div>
</template>

<script>
  export default {
    name: 'HeaderLinks',
  };
</script>

<style lang="less" scoped>
  @import (reference) '../shared.less';

  .header-links {
    display: flex;
    justify-content: space-between;
    align-self: center;
    flex-shrink: 0;

    @media @vertical {
      margin-top: @margins-v[long-v-padding] / 1.5;
    }

    @media @mobile-vertical {
      margin-top: @margins-mv[long-v-padding] / 1.5;
      flex-direction: column;
      align-items: center;
    }
  }

  a {
    .link();
  }

  a+a {
    margin-left: 5vh;

    @media @vertical {
      margin-left: 5vw;
    }

    @media @mobile {
      margin-left: 5vh;
    }

    @media @mobile-vertical {
      margin-left: unset;
      margin-top: 2.5vw;
    }
  }
</style>
